import { createContext, h } from 'preact';
import { useMemo, useReducer } from 'preact/hooks';
import bundleReducer from '../utils/bundleReducer';

export const ItemsContext = createContext({
  state: {
    defaultItems: null,
    items: null,
    bundle: null,
    isLoading: true,
    bundleInCart: false,
  },
  dispatch: null,
});

const ItemsProvider = ({ items: defaultItems, bundle, children }) => {
  // See this for info on implementation: https://hswolff.com/blog/how-to-usecontext-with-usereducer/

  const [state, dispatch] = useReducer(bundleReducer, {
    defaultItems: defaultItems,
    items: defaultItems,
    bundle: bundle,
    isLoading: false,
    bundleInCart: false,
  });

  const contextValue = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);

  return (
    <ItemsContext.Provider value={contextValue}>
      {children}
    </ItemsContext.Provider>
  );
};

export default ItemsProvider;
